import { Component, OnDestroy, OnInit } from '@angular/core';
import { ListJobDutiesService } from 'list-job-duties';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// import { AwaitLotterySelectionComponent } from '../../l1-visa/components/await-lottery-selection/await-lottery-selection.component';
// import { LcaJobDetailsPositionComponent } from '../../l1-visa/components/lca-job-details-position/lca-job-details-position.component';
// import { LcaJobDetailsWorkComponent } from '../../l1-visa/components/lca-job-details-work/lca-job-details-work.component';
// import { LcaSocCodeLibraryComponent } from 'lca-soc-code-library';
// import { SelectingLcaSocLibraryComponent } from 'selecting-lca-soc-library';

@Component({
  selector: 'app-job-description',
  templateUrl: './job-description.component.html',
  styleUrls: ['./job-description.component.scss']
})
export class JobDescriptionComponent implements OnInit, OnDestroy  {
  inputData: any;
  wizardInput: any;
  jobPositionTitle: any;
  isDataLoaded: boolean = false;
  observableSubscription$ = new Subject();
  // accordianHeader = [
  //   { header: "H-1B Lottery Selection Details", component: AwaitLotterySelectionComponent, item: 1 },
  //   { header: "Position Details", component: LcaJobDetailsPositionComponent, item: 2 },
  //   { header: "Identify Work Location", component: LcaJobDetailsWorkComponent, item: 3 },
  //   { header: "List of Duty", component: '', item: 4 },
  // ] 

  constructor(public listJobDutiesService:ListJobDutiesService, public immigrationWizardService: ImmigrationWizardService) {
  }

  ngOnInit(): void {
    this.immigrationWizardService.getWizardTaskDetails$().subscribe((res: any) => {
      if(res){
        let stepData = res?.taskStepDetails.find(data => data.isBeneficiaryAction==0 && data.stepName == "Enter Proposed Job Description");
        this.inputData = {
          "superTaskId": res.superTaskId,
          "subTaskId": res.id,
          "caseType": res.subTaskTypeCode,
          "caseId": res.petitionId, // 1519
          "petitionId": res.petitionId,
          "foreignCompanyId": null,
          "visatype": res.taskTypeDetails.visaType,
          "visaName": res.taskTypeDetails.visaName,
          "petitionType": res.taskTypeDetails.petitionType,
          "immSpecialistId": res.immSpecialistId,
          "attorneyId": res.attorneyId,
          "sponsorId": res.sponsorId,
          "familyId": res.familyId,
          "immigrationCategory": null,
          "immigrationCategoryName": null,
          "immigrationClassification": null,
          "immigrationClassificationName": null,
          "superTaskTypeCode": res.superTaskTypeCode,
          "getTaskType": res.taskTypeDetails.visaType,
          "jsonInput": null,
          "beneficiaryId": res.beneficiaryId,
          "relationshipCode": null,
          "taskTypeId": res.taskTypeId,
          "taskTypeSaveJsonId": null,
          "stepId": stepData?.id,
          "companyId": res.companyId,
          "petitionerId": res.taskStepDetails[0].petitionerId,
          "stepName": stepData?.stepName,
          "layoutCode": stepData?.stepActionList[0]?.layoutCode,
          "taskId": res.taskStepDetails[0].taskId,
          "isCustomStep": false,
          // "individualStepId": 6154,
          // "version": "wizard"
        }
        this.wizardInput = {
          title: 'Job Description',
          data: {
            taskId: res?.superTaskId,
            individual: res?.beneficiaryDetails?.firstName+" "+res?.beneficiaryDetails?.lastName,
            petitionType: res?.taskTypeDetails?.petitionType,
            status: res?.taskStatus?.name
          }
        }
        this.isDataLoaded = true;
        
        if(stepData?.stepStatusDetails?.stepStatusCode == "NEW"){
          let stepDetailsData = {
            "benchMarkActionCode": "",
            "endDate": "",
            "isAttorneyNotify": 0,
            "isBeneficiaryNotify": 0,
            "isPetitionerNotify": 0,
            "receiptCategory": "",
            "receiptDate": "",
            "receiptNumber": "",
            "receiptType": "",
            "responseCode": null,
            "responseNote": "",
            "reviewCode": null,
            "reviewNote": null,
            "startDate": "",
            "statusCode": "INPROGRESS",
            "stepNote": "",
            "notesAvailable": false
          }
          this.onLoadStatus(stepDetailsData);
        }
      }
    });
  }

  onLoadStatus(stepDetailsData){
    this.immigrationWizardService.postH1BLottery(this.inputData.visatype, this.inputData.subTaskId, this.inputData.stepId, stepDetailsData).subscribe((response: any) => {
      if (response && response.status === 200) {
       // updating the step status
      }
    });
  }

  jobSubmitted(event){
    if(event){
      this.jobPositionTitle = event;
    }
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
